import type { FunctionComponent } from "react"

import { isAfter } from "date-fns"
import { useParams } from "next/navigation"

import { Badge } from "@jobteaser/spark/components/Badge"
import { FlameFilled } from "@jobteaser/spark/components/Icons/FlameFilled"

import { WITHOUT_REGISTRATION } from "@/modules/events/constants"
import { useEventDetailsData } from "@/modules/events/hooks/useEventDetailsData"
import { useTranslation } from "@/modules/i18n/components/useTranslation"

import styles from "./SpotsLeft.module.css"

export type SpotsLeftProps = {
  counter: number
}

export const SpotsLeft: FunctionComponent<SpotsLeftProps> = ({ counter }) => {
  const { t } = useTranslation(["event_details"])
  const { eventSlug } = useParams<{ eventSlug: string }>()
  const event = useEventDetailsData(eventSlug)

  if (!event) {
    return null
  }

  const { registrationDetails } = event
  const currentDate = new Date()

  if (registrationDetails.type === WITHOUT_REGISTRATION) {
    return null
  }

  const deadline = new Date(registrationDetails.registrationDeadline ? registrationDetails.registrationDeadline : "")

  if (isAfter(currentDate, deadline)) {
    return null
  }

  return (
    <Badge
      color="purple"
      icon={FlameFilled}
      className={styles.spots}
      data-testid="event-details-registration-details-spots-left"
      isFaded
    >
      {t("event_details.spots", { count: counter })}
    </Badge>
  )
}
